const mediaQuery = window.matchMedia('(min-width: 769px)');

document.addEventListener('DOMContentLoaded', function (){

  /*var button = document.getElementById('point-reset');
  if(button !== null){
    button.addEventListener('click', function(e){
      e.preventDefault();
      location.href = '/account/login';
    });
  }*/

  window.addEventListener('load', function () {

    if (window.location.hash == '') {
      return false;
    }

    const el = document.querySelector(window.location.hash);
    const header = document.getElementById('shopify-section-header');

    if (el !== null && getComputedStyle(header).position == 'sticky') {

      const element = document.querySelector(window.location.hash);
      const offset = document.getElementById('SiteHeader').clientHeight;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      /*
      var el = document.querySelector(window.location.hash);
      if (el !== null) {
        el.scrollIntoView({ behavior: 'smooth' });
      }*/
    }
  }, false);

  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

  anchorLinksArr.forEach(link => {
    link.addEventListener('click', function (e){
      e.preventDefault();
      const element = document.querySelector(link.hash);
      const header = document.getElementById('shopify-section-header');
      let offset = 0;
      if(getComputedStyle(header).position == 'sticky'){
        offset = document.getElementById('SiteHeader').clientHeight;
      }
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  });

});



